// extracted by mini-css-extract-plugin
module.exports = {"root":"SubjectCard_root__LRVVL","imageWrapper":"SubjectCard_imageWrapper__JKOD8","title":"SubjectCard_title__MvUg1","description":"SubjectCard_description__VzHmD"};